import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { DataService } from '../../../core/services/data.service';
import { DBPreCacheModel, StatusInfo } from '../../../core/models/classes/db-precache';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dbprecache',
  templateUrl: './dbprecache.component.html',
  styleUrls: ['./dbprecache.component.scss'],
})

export class DbprecacheComponent implements OnInit{
  cacheInfo: DBPreCacheModel;
  cachedDate: string;
  cachedTime: string;
  totTime: string;
  statusText: string;
  cacheInProgress:boolean = false;

  constructor(
    private _snackBar: MatSnackBar,
    private dataService: DataService,
    public datepipe: DatePipe,
    public dialogRef: MatDialogRef<DbprecacheComponent>
  ) {}

  ngOnInit(): void {
    this.dataService.getDBPreCacheInfo().subscribe({
      next: (data) => {
        this.cacheInfo = data;
        this.calculateTime();
        this.getStatusInfo(this.cacheInfo.status);
      },
    });
  }

  calculateTime(){
    if(this.cacheInfo.start !== null && this.cacheInfo.end !== null){
      let itemA = this.cacheInfo.start.split(" ");
      let itemB = this.cacheInfo.end.split(" ");

      //Cache start date
      this.cachedDate = itemA[0];
      var startDate = this.cachedDate.split('.');
      var endDate = itemB[0].split('.');
      var startTime = 0;
      var endTime = 0;

      if(startDate.length === 3 && endDate.length === 3){
        const [day, month, year] = startDate;
        const dateObjStart = new Date(+year, +month - 1, +day);

        const [dy, mnt, yr] = endDate;
        const dateObjEnd = new Date(+yr, +mnt - 1, +dy);

        let hmsA = itemA[1].split(".");
        this.cachedTime = hmsA[0];
        let hmsB = itemB[1].split(".");
        let starthms = hmsA[0].split(":");
        let endhms = hmsB[0].split(":");

        startTime  = new Date(Number(year),Number(month),Number(day),Number(starthms[0]),Number(starthms[1]),Number(starthms[2])).getTime();
        endTime  = new Date(Number(yr),Number(mnt),Number(dy),Number(endhms[0]),Number(endhms[1]),Number(endhms[2])).getTime();
        var diff = (endTime - startTime)/1000;
        diff /= 60;

        //Total time taken
        this.totTime = Math.abs(Math.round(diff)) + " min";
      }
    }
  }

  getStatusInfo(tStat:StatusInfo)
  {
      this.statusText = ($localize.locale === 'en-US') ? "Failed" : "Gescheitert";
      switch (tStat)
      {
          case 1:
            this.statusText = ($localize.locale === 'en-US') ? "In Progress" : "In Bearbeitung";
            this.cacheInProgress = true;
              break;
          case 9:
            this.statusText = ($localize.locale === 'en-US') ? "Failed" : "Gescheitert";
              break;
          case 2:
            this.statusText = ($localize.locale === 'en-US') ? "Successfully completed With Warnings" : "Erfolgreich abgeschlossen mit Warnungen";
              break;
          case 3:
            this.statusText = ($localize.locale === 'en-US') ? "Completed" : "Abgeschlossen";
              break;
          case 0:
            this.statusText = ($localize.locale === 'en-US') ? "New" : "Neu";
              break;
      }
  }

  onStart(): void {
    this._snackBar.open($localize `DB Precache started`, '', {
              duration: 3000
            });
    this.dialogRef.close();
    this.runDBPreCache();
  }

  runDBPreCache(){
    this.dataService.runDBPreCache().subscribe({
      next: (data) => {
        if(data.status === 200){
          this._snackBar.open($localize `DB Precache successful`, '', {
            duration: 3000
          });
        }
        else{
          this._snackBar.open($localize `DB Precache failed`, '', {
            duration: 3000
          });
        }
      },
    });
  }
}
